import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import ScoreCardSF from '../../../components/superUser/score/ScoreCardSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const ScoreCardPageUI = ({context, account}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_scard' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!account} account={account} page='scoreCard' dimension='w768'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <ScoreCardSF context={context} account={account} />
    }
  </SuperUserAccountPageUI>

export default ScoreCardPageUI
